import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import RadioUnchecked from '@/components/icons/RadioUnchecked.vue';
import RadioChecked from '@/components/icons/RadioChecked.vue';
import UncheckedBox from '@/components/icons/UncheckedBox.vue';
import CheckedBox from '@/components/icons/CheckedBox.vue';
import Logo from '@/components/icons/Logo.vue';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      CheckedBox: {
        component: CheckedBox,
      },
      Logo: {
        component: Logo,
      },
      RadioUnchecked: {
        component: RadioUnchecked,
      },
      RadioChecked: {
        component: RadioChecked,
      },
      UncheckedBox: {
        component: UncheckedBox,
      },
    },
  },
  theme: {
    themes: {
      light: {
        primary: '#6558f5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
});
